import { useParams, useNavigate } from "react-router-dom";
import { useState } from "react";
import useRead from "./useRead";
import usePut from "./usePut";
import toast from "react-hot-toast";

const useTdsRegimeComparison = () => {
  const { company_employee_id, financial_year_id } = useParams();
  const navigate = useNavigate();
  const [selectedRegime, setSelectedRegime] = useState(null);
  // Fetch TDS data
  const { list: tdsData, isLoading } = useRead({
    url: "tds/get-user-response",
    initialData: {
      company_employee_id: parseInt(company_employee_id),
      screen: "MASTER",
      financial_year_id: parseInt(financial_year_id)
    },
    method: "GET",
    onSuccess: (data) => {
      if (data?.data?.main_submission_data?.employee_regime_selection?.regime) {
        setSelectedRegime(data.data.main_submission_data.employee_regime_selection.regime);
      }
    },
    onError: (error) => {
      console.error("Error fetching TDS data:", error);
      toast.error("Error loading data");
    },
  });

  // Submit regime change
  const { handleAuth: submitRegimeChange, isLoading: isSubmitting } = usePut({
    url: "tds/employee-regime/update",
    onSuccess: () => {
      toast.success("Tax regime updated successfully");
      navigate(`/employee-details/${company_employee_id}/investments-and-proofs`);
    },
    onError: (error) => {
      console.error("Error updating regime:", error);
      toast.error("Error updating tax regime. Please try again.");
    },
  });

  const handleSubmit = () => {
    const employeeRegimeSelectionId = tdsData.data?.data?.main_submission_data?.employee_regime_selection?.employee_regime_selection_id;

    const payload = {
      employee_regime_selection_id: parseInt(employeeRegimeSelectionId),
      company_employee_id: parseInt(company_employee_id),
      regime: selectedRegime
    };

    submitRegimeChange.mutate(payload);
  };

  return {
    tdsData: tdsData.data?.data,
    isLoading: tdsData.isLoading,
    selectedRegime,
    setSelectedRegime,
    handleSubmit,
    isSubmitting
  };
};

export default useTdsRegimeComparison;
